import Swal from "sweetalert2"; // 引入 SweetAlert2 用於提示訊息
export default {
  data() {
    return {
      email: "", // 儲存使用者輸入的電子郵件
      successMessage: "", // 儲存成功的提示訊息
      errorMessage: "", // 儲存錯誤訊息
      loading: false, // 控制是否顯示進度條
      countdown: 0, // 倒數計時初始值
      timer: null, // 記錄計時器 ID
      successMessageTimer: null, // 成功訊息延遲清除的計時器 ID
    };
  },

  computed: {
    buttonDisabled() {
      // 控制送出按鈕是否禁用
      return this.loading || this.countdown > 0;
    },
    buttonText() {
      // 按鈕文字，根據倒數計時進行切換
      return this.countdown > 0 ? `請稍候 ${this.countdown} 秒` : "送出";
    },
  },

  methods: {
    async handleSubmit() {
      // 驗證輸入是否為空
      if (!this.email) {
        Swal.fire({
          icon: "warning", // 使用警告圖示
          title: "格式錯誤", // 標題
          text: "請輸入有效的電子郵件地址！", // 提示訊息
          confirmButtonText: "確定", // 按鈕文字
        });
        return;
      }

      this.loading = true; // 開始加載

      try {
        // 發送 POST 請求到後端 API
        const response = await fetch(
          "https://localhost:7107/api/Forgot/request-reset",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json", // 指定請求類型為 JSON
            },
            body: JSON.stringify(this.email), // 傳遞 email 為純文字
          }
        );

        // 根據後端回應處理
        if (response.ok) {
          const data = await response.json();
          this.successMessage = data.message || "密碼重置連結已成功發送！"; // 通用成功訊息
          this.errorMessage = "";
          this.startCountdown(); // 開始倒數計時
        } else {
          const errorData = await response.json();
          this.errorMessage =
            errorData.message || "伺服器發生錯誤，請稍後再試。"; // 支援通用錯誤訊息
          this.successMessage = "";
        }
      } catch (error) {
        console.error("Error occurred while fetching:", error);
        this.errorMessage = "無法連接伺服器，請檢查您的網路連線。";
        this.successMessage = "";
      } finally {
        this.loading = false; // 隱藏進度條
      }
    },

    startCountdown() {
      this.countdown = 15; // 設定倒數秒數

      // 設置定時器，在倒數結束時清除成功訊息
      this.successMessageTimer = setTimeout(() => {
        this.successMessage = ""; // 清除成功訊息
      }, this.countdown * 1000); // 設置與倒數秒數一致的延時

      // 啟動每秒遞減的倒數計時
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--; // 每秒減一
        } else {
          clearInterval(this.timer); // 清除倒數計時器
          this.timer = null; // 重置計時器 ID
        }
      }, 1000); // 每 1 秒執行一次
    },
  },
  beforeDestroy() {
    // 清除所有計時器，防止內存洩漏
    if (this.timer) clearInterval(this.timer);
    if (this.successMessageTimer) clearTimeout(this.successMessageTimer);
  },
};
